import $ from 'jquery';

var countdownTimer = $('.js-countdownTimer');

$(countdownTimer).each(function() {
    var getTargetDateTimeAttribute = $(this).attr('data-countdown-timer-date-time');
    var countdownDateify = new Date(getTargetDateTimeAttribute.replace(/-/g, '/'));
    var countdownDate = countdownDateify.getTime();

    var getCountdownTimerHideAfterElapse = $(this).attr('data-countdown-timer-hide-after-elapse');
    var getCountdownTimer = $(this).find('.c-countdown-timer');

    var getCountdownTimerShowCustomMessageBeforeTimerEnds = $(this).attr('data-countdown-timer-show-custom-message-before-timer-ends');
    var getCountdownTimerShowCustomMessageBeforeTimerEndsDateTime = $(this).attr('data-countdown-timer-show-custom-message-before-timer-ends-date-time');

    var whenToShowCountdownTimerShowCustomMessageBeforeTimerEndsDateTime = '';
    var whenToShowCountdownTimerCustomMessage = '';
    if ( getCountdownTimerShowCustomMessageBeforeTimerEndsDateTime ) {
        whenToShowCountdownTimerShowCustomMessageBeforeTimerEndsDateTime = new Date(getCountdownTimerShowCustomMessageBeforeTimerEndsDateTime).getTime();
        whenToShowCountdownTimerCustomMessage = countdownDate - whenToShowCountdownTimerShowCustomMessageBeforeTimerEndsDateTime;
    }

    var showCustomMessageBeforeTheCountdownTimerReachesItsEnd = $(this).find('.js-showCustomMessageBeforeTheCountdownTimerReachesItsEnd');

    var getCountdownTimerShowCustomMessageAfterElapse = $(this).attr('data-countdown-timer-show-custom-message-after-elapse');
    var showCustomMessageAfterCountdownTimerElapses = $(this).find('.js-showCustomMessageAfterCountdownTimerElapses');

    var thisCountdownTimer = $(this);

    var x = setInterval(function() {
        var now = new Date().getTime();
        var distance = countdownDate - now;

        // If the countdown has not elapsed
        if ( distance > 0 ) {

            var days = Math.floor(distance / (1000 * 60 * 60 * 24));

            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            if ( hours < 10 ) {
                hours = '0' + hours;
            }

            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            if ( minutes < 10 ) {
                minutes = '0' + minutes;
            }

            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            if ( seconds < 10 ) {
                seconds = '0' + seconds;
            }

            thisCountdownTimer.find('.js-countdownTimerDisplayDays').text(days);
            thisCountdownTimer.find('.js-countdownTimerDisplayHours').text(hours);
            thisCountdownTimer.find('.js-countdownTimerDisplayMinutes').text(minutes);
            thisCountdownTimer.find('.js-countdownTimerDisplaySeconds').text(seconds);
        }

        // If a custom message is set to appear at a certain point before the countdown timer ends
        if (
            getCountdownTimerShowCustomMessageBeforeTimerEnds &&
            whenToShowCountdownTimerShowCustomMessageBeforeTimerEndsDateTime &&
            whenToShowCountdownTimerCustomMessage > 0 &&
            whenToShowCountdownTimerCustomMessage > distance &&
            $(showCustomMessageBeforeTheCountdownTimerReachesItsEnd).is(':hidden')
        ) {
            // Show custom message before timer elapses
            $(showCustomMessageBeforeTheCountdownTimerReachesItsEnd).show();
        }

        // If the countdown has elapsed and timer is set to hide after elapsing
        if ( distance < 0 && getCountdownTimerShowCustomMessageAfterElapse ) {
            clearInterval(x);
            if ( getCountdownTimerHideAfterElapse ) {
                $(getCountdownTimer).css('display', 'none');
            }
            if ( getCountdownTimerShowCustomMessageAfterElapse ) {
                // Hide custom message that shows before timer elapses if it is visible
                $(showCustomMessageBeforeTheCountdownTimerReachesItsEnd).css('display', 'none');

                // Show custom message after timer elapses
                $(showCustomMessageAfterCountdownTimerElapses).css('display', 'block');
            }
        }

    }, 1000);

});
